import logo from "../assets/logo/logo.png";

const footerData = {
  logo: logo,

  description:
    "Quality Sports Surface specializes in designing and constructing premium sports infrastructure across India. From basketball courts and tennis courts to football turf, running tracks and multi-sport arenas, we deliver international-quality sports facilities built to last.",

  phone: "+91 98765 43210",

  email: "info@qualitysportssurface.com",

  address: "Delhi NCR, India",

  timing: "Mon - Sat | 9:00 AM - 7:00 PM",

  links: [
    {
      title: "Home",
      link: "/",
    },
    {
      title: "About Us",
      link: "/about",
    },
    // {
    //   title: "Services",
    //   link: "/services",
    // },
    {
      title: "Projects",
      link: "/projects",
    },
    {
      title: "Gallery",
      link: "/gallery",
    },
    {
      title: "Contact",
      link: "/contact",
    },
  ],

  services: [
    {
      title: "Basketball Court",
      link: "/services/basketball-court",
    },
    {
      title: "Tennis Court",
      link: "/services/tennis-court",
    },
    {
      title: "Football Field",
      link: "/services/football-field",
    },
    {
      title: "Badminton Court",
      link: "/services/badminton-court",
    },
    {
      title: "Running Track",
      link: "/services/running-track",
    },
    {
      title: "Pickleball Court",
      link: "/services/pickleball-court",
    },
    {
      title: "Wooden Flooring",
      link: "/services/wooden-flooring",
    },
    {
      title: "EPDM Flooring",
      link: "/services/epdm-flooring",
    },
  ],
};

export default footerData;
